import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    Box,
    Tab,
    Tabs,
} from '@material-ui/core';

import {
    Person as PersonIcon,
    Lock as LockIcon,
    Payment as BillingIcon,
    Security as SecurityIcon,
} from '@material-ui/icons';

import Widget from '../../../components/Widget/Widget.jsx';

import { useStyles } from '../profile.styles';

const ICONS = {
    User: <PersonIcon />,
    Security: <SecurityIcon />,
    Account: <LockIcon />,
    Billing: <BillingIcon />,
};

function ProfileTabs (props) {
    const {
        onTabChange,
        tabIndex = 0,
        tabs = [],
    } = props;

    const [tab, setTab] = useState(tabIndex);
    const classes = useStyles();

    function handleTabChange (event, newValue) {
        setTab(newValue);
        onTabChange(newValue);
    }

    useEffect(() => {
        setTab(tabIndex);
    }, [tabIndex]);

    return (
        <Grid item xs={12}>
            <Widget>
                <Box display={'flex'} justifyContent={'center'}>
                    <Tabs
                        indicatorColor='primary'
                        textColor='primary'
                        value={tab}
                        onChange={handleTabChange}
                        aria-label='Tabs'
                    >
                        {tabs.map((tabInfo) => (
                            <Tab
                                key={tabInfo.id}
                                label={tabInfo.label}
                                icon={ICONS[tabInfo.label]}
                                classes={{ wrapper: classes.icon }}
                            />
                        ))}
                    </Tabs>
                </Box>
            </Widget>
        </Grid>
    );
}

ProfileTabs.propTypes = {
    onTabChange: PropTypes.func,
    tabs: PropTypes.array,
};

ProfileTabs.defaultProps = {
    onTabChange: () => {},
    tabs: [],
};

export default ProfileTabs;
